// SEO-EXPANSION v4: additive, no behavior change to existing pages.
const TAILS = [
  "| DrHint",
  "— Live Today",
  "· Verified",
  "| DrHint Live",
  "— Updated Daily",
  "· DrHint Rates",
  "| Real-Time",
  "— Trusted Source",
];

export function brandTail(slug: string): string {
  const code = slug.length > 0 ? slug.charCodeAt(0) : 0;
  return TAILS[code % TAILS.length];
}

export function hashSeed(input: string): number {
  let h = 2166136261;
  for (let i = 0; i < input.length; i++) {
    h ^= input.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return Math.abs(h);
}

export function pick<T>(arr: readonly T[], seed: number, offset = 0): T {
  return arr[(seed + offset) % arr.length];
}